// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type ApiError, type Erzeuger } from "../../api";
import { useGetErzeuger as useGetter } from "../hooks";
import { useQuery, type UseQueryOptions } from "react-query";

export function useErzeuger(
  erzeugerId: string,
  options: Omit<
    UseQueryOptions<Erzeuger, ApiError>,
    "queryKey" | "queryFn"
  > = {}
): Erzeuger {
  const getter = useGetter();
  return useQuery(["erzeuger", erzeugerId], () => getter(erzeugerId), options)
    .data!;
}
